/**
 * Route guard for READY modules (BHM-CLD-REQ-027).
 * SUPERADMIN passes; employees need the explicit module permission resolved by the API.
 * Direct URL without permission → redirect to /dashboard.
 */
import { useEffect, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { usePermissionStore } from '../stores/permissionStore';
import { isSuperAdmin } from '../utils/permissions';

export default function RequireModulePermission({
  permission,
  anyOf,
  children,
}: {
  permission: string;
  /** Permisos alternativos que también dan acceso (p. ej. acceso por pertenencia al proyecto). */
  anyOf?: string[];
  children: ReactNode;
}) {
  const user = useAuthStore((s) => s.user);
  const permissions = usePermissionStore((s) => s.permissions);
  const loadedFor = usePermissionStore((s) => s.loadedFor);
  const load = usePermissionStore((s) => s.load);
  const sa = isSuperAdmin(user?.role ?? '');

  useEffect(() => {
    if (user?.id && !sa) void load(user.id);
  }, [user?.id, sa, load]);

  if (sa) return <>{children}</>;
  if (!user?.id || loadedFor !== user.id) {
    return (
      <div className="flex h-64 items-center justify-center text-sm text-on-surface-variant" role="status">
        Comprobando permisos…
      </div>
    );
  }
  if (!permissions.includes(permission) && !(anyOf ?? []).some((p) => permissions.includes(p))) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
